import { call, put, takeEvery } from 'redux-saga/effects';
import { SCAN_CONSTANTS } from '../constants/myDomainScanConstants';
import { fastDomainCheckSuccess, fastDomainCheckFailure, getScansSuccess, getScansFailure, getOemScansSuccess, getOemScansFailure } from '../actions/myDomainScanActions';
import { fastDomainCheckApi, getOemScansApi, getScansApi } from '../api/myDomainScanApi';
import { toast } from 'react-toastify';

function* fastDomainCheckSaga(action) {
  try {
    const response = yield call(fastDomainCheckApi, action.payload);
    if (response?.data?.message) {
      toast.success(response.data.message);
    }
    yield put(fastDomainCheckSuccess(response.data));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Scan failed';
    console.error('Fast domain check error:', errorMessage);
    toast.error(errorMessage);
    yield put(fastDomainCheckFailure(errorMessage));
  }
}

function* getScansSaga(action) {
  try {
    const response = yield call(getScansApi, action.payload);
    yield put(getScansSuccess(response.data));
  } catch (error) {
    yield put(getScansFailure(error.response?.data?.message || 'Failed to fetch scans'));
  }
}

function* getOemScansSaga(action) {
  try {
    const response = yield call(getOemScansApi, action.payload);
    yield put(getOemScansSuccess(response.data));
  } catch (error) {
    yield put(getOemScansFailure(error.response?.data?.message || 'Failed to fetch OEM scans'));
  }
}

function* scanSaga() {
  yield takeEvery(SCAN_CONSTANTS.FAST_DOMAIN_CHECK_REQUEST, fastDomainCheckSaga);
  yield takeEvery(SCAN_CONSTANTS.GET_SCANS_REQUEST, getScansSaga);
  yield takeEvery(SCAN_CONSTANTS.GET_OEM_SCANS_REQUEST, getOemScansSaga);
}

export default scanSaga;